import { mailingReducer } from './reducers';

export default {
  mailing: mailingReducer
};
